import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { assetsObjectTypeConfigurationRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsObjectTypeConfigurationRoute.tsx';
import {
	toPackageName,
	APP_NAMES,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { assetsObjectTypeSettingsEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-configure-object-type/src/entrypoint.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsObjectTypeSettingsPageEntryPoint = createChromelessEntryPoint({
	main: assetsObjectTypeSettingsEntryPoint,
});

export const assetsObjectTypeConfigurationRouteEntry = createEntry(
	assetsObjectTypeConfigurationRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: Spinner,
		entryPoint: () => assetsObjectTypeSettingsPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-configure-object-type',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],

		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION,
				packageName: toPackageName(APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION),
				teamName: 'aurum',
			},
		},

		ufoName: 'service-management.insight-cmdb-object-type-configuration',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-assets-entries/src/assetsObjectTypeConfigurationRouteEntry.tsx',
				whichExportToUse: 'assetsObjectTypeConfigurationRouteEntry',
			},

			enabled: true,
		},
	}),
);
